import { createContext, ReactElement, ReactNode, useContext, useState } from 'react'

interface CookieConsentProviderProps {
  children: ReactNode
}

interface CookieConsentContextInterface {
  consent: boolean | null
  setConsent: (value: boolean) => void
}

const CookieConsentContext = createContext<CookieConsentContextInterface>({
  consent: null,
  setConsent: () => {
    throw new Error('setConsent called outside of CookieConsentProvider')
  },
})

export const useCookieConsent = (): CookieConsentContextInterface =>
  useContext(CookieConsentContext)

export const CookieConsentProvider = ({ children }: CookieConsentProviderProps): ReactElement => {
  const [consent, setConsentState] = useState<boolean | null>(() => {
    const stored = localStorage.getItem('cookieConsent')
    return stored === null ? null : stored === 'true'
  })

  const setConsent = (value: boolean): void => {
    localStorage.setItem('cookieConsent', value.toString())
    setConsentState(value)
  }

  return (
    <CookieConsentContext.Provider value={{ consent, setConsent }}>
      {children}
    </CookieConsentContext.Provider>
  )
}
